//#region IMPORTS
import {
  setInstoreOrderTypeParams,
  clearInstoreOrderTypeParam,
  clearInstoreOrderTypeParams,
} from "../../features/instoreOrderTypes/instoreOrderTypesSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { ReactNode } from "react";
import MainFilterBarItem from "../_layout/MainFilterBarItem";
import MainFilterBar from "../_layout/MainFilterBar";
//#endregion

//#region INTERFACE
interface Props {
  extensionButtons?: ReactNode;
}
//#endregion

export default function InstoreOrderTypesFilterBar({ extensionButtons }: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  const { page, limit, sort, ...params } = useAppSelector(
    ({ instoreOrderTypes }) => instoreOrderTypes.instoreOrderType_params
  );
  const { loading } = useAppSelector(({ instoreOrderTypes }) => instoreOrderTypes);
  //#endregion

  //#region RENDER
  return (
    <MainFilterBar
      paramNamesList={params}
      clearAllFiltersHandler={() => dispatch(clearInstoreOrderTypeParams())}
      extensionButtons={extensionButtons}
      clearFilterHandler={(paramName: string) => {
        dispatch(clearInstoreOrderTypeParam(paramName));
      }}
      disabled={loading}
    >
      {/* name */}
      <MainFilterBarItem
        filterParameterName="name"
        displayExplanation="Search the instore order types by name"
        clearFilterAction={() => dispatch(clearInstoreOrderTypeParam("name"))}
        selectedValue={params.name}
        filterAction={(value: string) =>
          dispatch(setInstoreOrderTypeParams({ name: value }))
        }
        displayText="Order type name"
        selected={!!params.name}
      />

      {/* shortName */}
      <MainFilterBarItem
        filterParameterName="shortName"
        displayExplanation="Search the instore order types by short name"
        clearFilterAction={() => dispatch(clearInstoreOrderTypeParam("shortName"))}
        selectedValue={params.shortName}
        filterAction={(value: string) =>
          dispatch(setInstoreOrderTypeParams({ shortName: value }))
        }
        displayText="Order type short name"
        selected={!!params.shortName}
      />
    </MainFilterBar>
  );
  //#endregion
}
